import { CheckpointsMap } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import { IProjectStage, IProjectType, ProjectStagesMap } from '../projectTypes.types'
import timeUtils from 'utils/time.utils'

const getProjectStageDuration = (projectStage: Pick<IProjectStage, 'checkpoints'>, checkpointsMap: CheckpointsMap) => {
  return timeUtils.sToDays(
    projectStage?.checkpoints?.reduce(
      (dur, { projectCheckpointId }) => dur + (checkpointsMap[projectCheckpointId]?.duration ?? 0),
      0
    ) ?? 0
  )
}

const getProjectTypeDuration = (
  projectType: Pick<IProjectType, 'projectStages'>,
  projectStagesMap: ProjectStagesMap,
  checkpointsMap: CheckpointsMap
) => {
  return (
    projectType.projectStages?.reduce(
      (dur, { projectStageId }) => dur + getProjectStageDuration(projectStagesMap[projectStageId], checkpointsMap),
      0
    ) ?? 0
  )
}

const durationUtils = {
  getProjectStageDuration,
  getProjectTypeDuration,
}

export default durationUtils
